import RecordTemplate from "../../../../domain/record/template/RecordTemplate";
import WidgetItem     from "../../../../domain/record/widget/item/WidgetItem";
import WidgetItems    from "../../../../domain/record/widget/item/WidgetItems";
import Widget         from "../../../../domain/record/widget/Widget";
import {
  ACTION_TYPE,
  AddRecordTemplateWidgetAction,
  AddRecordTemplateWidgetItemAction,
  DeleteRecordTemplateWidgetAction,
  DeleteRecordTemplateWidgetItemAction,
  MoveRecordTemplateWidgetAction,
  RecordTemplateAction,
  SetRecordTemplateAction,
  SetRecordTemplateNameAction,
  SetRecordTemplateWidgetItemTitleAction,
  SetRecordTemplateWidgetTitleAction
}                     from "./RecordTemplateAction";

const reduceSetRecordTemplate = (action: SetRecordTemplateAction): RecordTemplate => action.template;
const reduceSetRecordTemplateName = (state: RecordTemplate, action: SetRecordTemplateNameAction): RecordTemplate => new RecordTemplate(state.id, state.revision, action.name, state.widgets);
const reduceAddRecordTemplateWidget = (state: RecordTemplate, action: AddRecordTemplateWidgetAction): RecordTemplate => new RecordTemplate(state.id, state.revision, state.name, state.widgets.add(action.widget));
const reduceDeleteRecordTemplateWidget = (state: RecordTemplate, action: DeleteRecordTemplateWidgetAction): RecordTemplate => new RecordTemplate(state.id, state.revision, state.name, state.widgets.delete(action.widgetIndex));
const reduceMoveRecordTemplateWidget = (state: RecordTemplate, action: MoveRecordTemplateWidgetAction): RecordTemplate => new RecordTemplate(state.id, state.revision, state.name, state.widgets.replace(action.widgetIndex, action.widget));
const reduceAddRecordTemplateWidgetItem = (state: RecordTemplate, action: AddRecordTemplateWidgetItemAction): RecordTemplate => {
  const widget: Widget = state.widgets.findByIndex(action.widgetIndex);
  const widgetItems: WidgetItems = widget.items.add(action.widgetItem);
  return new RecordTemplate(state.id, state.revision, state.name, state.widgets.replace(action.widgetIndex, new Widget(widget.id, widget.type, widget.coordinate, widget.title, widget.value, widgetItems)));
};

const reduceDeleteRecordTemplateWidgetItem = (state: RecordTemplate, action: DeleteRecordTemplateWidgetItemAction): RecordTemplate => {
  const widget: Widget = state.widgets.findByIndex(action.widgetIndex);
  const widgetItems: WidgetItems = widget.items.delete(action.widgetItemIndex);

  return new RecordTemplate(state.id, state.revision, state.name, state.widgets.replace(action.widgetIndex, new Widget(widget.id, widget.type, widget.coordinate, widget.title, widget.value, widgetItems)));
};

const reduceSetRecordTemplateWidgetTitle = (state: RecordTemplate, action: SetRecordTemplateWidgetTitleAction): RecordTemplate => {
  const widget: Widget = state.widgets.findByIndex(action.widgetIndex);
  return new RecordTemplate(state.id, state.revision, state.name, state.widgets.replace(action.widgetIndex, new Widget(widget.id, widget.type, widget.coordinate, action.widgetTitle, widget.value, widget.items)));
};

const reduceSetRecordTemplateWidgetItemTitle = (state: RecordTemplate, action: SetRecordTemplateWidgetItemTitleAction): RecordTemplate => {
  const widget: Widget = state.widgets.findByIndex(action.widgetIndex);
  const widgetItem: WidgetItem = widget.items.findByIndex(action.widgetItemIndex);
  return new RecordTemplate(state.id, state.revision, state.name, state.widgets.replace(action.widgetIndex, new Widget(widget.id, widget.type, widget.coordinate, widget.title, widget.value, widget.items.replace(action.widgetItemIndex, new WidgetItem(widgetItem.id, action.widgetItemTitle, widgetItem.value)))));
};

const recordTemplateReducer = (state: RecordTemplate = new RecordTemplate(), action: RecordTemplateAction): RecordTemplate => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_RECORD_TEMPLATE:
      return reduceSetRecordTemplate(action as SetRecordTemplateAction);
    case ACTION_TYPE.SET_RECORD_TEMPLATE_NAME:
      return reduceSetRecordTemplateName(state, action as SetRecordTemplateNameAction);
    case ACTION_TYPE.ADD_RECORD_TEMPLATE_WIDGET:
      return reduceAddRecordTemplateWidget(state, action as AddRecordTemplateWidgetAction);
    case ACTION_TYPE.DELETE_RECORD_TEMPLATE_WIDGET:
      return reduceDeleteRecordTemplateWidget(state, action as DeleteRecordTemplateWidgetAction);
    case ACTION_TYPE.MOVE_RECORD_TEMPLATE_WIDGET:
      return reduceMoveRecordTemplateWidget(state, action as MoveRecordTemplateWidgetAction);
    case ACTION_TYPE.ADD_RECORD_TEMPLATE_WIDGET_ITEM:
      return reduceAddRecordTemplateWidgetItem(state, action as AddRecordTemplateWidgetItemAction);
    case ACTION_TYPE.DELETE_RECORD_TEMPLATE_WIDGET_ITEM:
      return reduceDeleteRecordTemplateWidgetItem(state, action as DeleteRecordTemplateWidgetItemAction);
    case ACTION_TYPE.SET_RECORD_TEMPLATE_WIDGET_TITLE:
      return reduceSetRecordTemplateWidgetTitle(state, action as SetRecordTemplateWidgetTitleAction);
    case ACTION_TYPE.SET_RECORD_TEMPLATE_WIDGET_ITEM_TITLE:
      return reduceSetRecordTemplateWidgetItemTitle(state, action as SetRecordTemplateWidgetItemTitleAction);
  }
};

export default recordTemplateReducer;
